"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHydratedRef = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useHydratedRef = () => {
  const [, setIsLoaded] = React.useState(false);
  const ref = React.useRef(null);
  React.useEffect(() => {
    // Frequently, components must wait for ref.current to be resolved to a node.
    // On the initial mount it is null, and we have to update the state
    // within `useEffect` in order to cause a second render to occur,
    // at which point ref.current will have been resolved to a node.
    //
    // We can call anything here that updates state and thus triggers a rerender,
    setIsLoaded(true);
  }, []);
  return ref;
};
exports.useHydratedRef = useHydratedRef;
//# sourceMappingURL=useHydratedRef.js.map